import { render, staticRenderFns } from "./instaImgEditor.vue?vue&type=template&id=1363df9f&scoped=true&"
import script from "./instaImgEditor.vue?vue&type=script&lang=js&"
export * from "./instaImgEditor.vue?vue&type=script&lang=js&"
import style0 from "./instaImgEditor.vue?vue&type=style&index=0&id=1363df9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1363df9f",
  null
  
)

export default component.exports